import request from '@/utils/request'

// 获取商户
export function getUserInfo (data) {
  return request({
    url: '/api/commercials/user/info',
    method: 'get',
    data
  })
}
// 获取商户下用户
export function getUserCurrent (data) {
  return request({
    url: '/api/commercials/user/current',
    method: 'get',
    data
  })
}
// 根据token获取商户用户
export function getInfoToken (data) {
  return request({
    url: '/api/commercials/info/token',
    method: 'post',
    data
  })
}
// 根据token获取商户用户
export function getCurrentPage (params) {
  return request({
    url: '/api/commercials/user/current/page',
    method: 'get',
    params
  })
}
// 商户管理员新增用户
export function getUserAdd (data) {
  return request({
    url: '/api/commercials/user/add',
    method: 'post',
    data
  })
}
// 商户管理员修改用户
export function getUserEdit (data) {
  return request({
    url: '/api/commercials/user/edit',
    method: 'post',
    data
  })
}
// 获取用户信息id查询
export function getDataUeserId (data) {
  return request({
    url: `/data/users/${data}`,
    method: 'get',
    data
  })
}
// 获取用户信息id查询
export function getUeserInfo (data) {
  return request({
    url: `/data/commercials/userinfo/${data}`,
    method: 'get',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/identity.js